.container {
  background-color: var(--tuna-palette-layers);
  transition: width 0.3s;
  z-index: 1;
  border-left: solid 1px var(--tuna-palette-divider);
  transform: translateZ(0);
}

.toolPanel {
  transition: all 0.25s;
  overflow: auto;
  flex: 1;
  /* Flex items default to `min-height: auto`, which prevents shrinking
   * below their intrinsic content height. With a tall Context panel
   * (Circle of Fifths + ScaleMatchList + chord match list + …) the
   * `overflow: auto` above never engages because the tool panel just
   * grows past its allocated row height instead of clipping. Setting
   * `min-height: 0` lets flex constrain the height and the scrollbar
   * actually appear. GH #1366. */
  min-height: 0;
}

/*
 * GH #1366 (follow-up): `min-height: 0` on the panel above is necessary but not
 * sufficient for the Context panel. Its content is a stack of Accordions
 * (`<details class="accordion">`), and `.accordion` sets `overflow: hidden`.
 * Per the flexbox spec, a flex item's automatic minimum size (`min-height:
 * auto`) collapses to 0 when `overflow` is not `visible` — so the Accordions
 * become infinitely shrinkable, and this flex column compresses them to fit
 * (clipping their content) instead of overflowing. The scrollbar therefore
 * never appears. Pinning the direct children to `flex-shrink: 0` keeps them at
 * their natural height so the column actually overflows and scrolls. Panels
 * that manage their own internal scroll (e.g. EntityNotes' `<VBox flex:1>`)
 * set `flex: 1` inline, which overrides this and is unaffected.
 */
.toolPanel > * {
  flex-shrink: 0;
}

.iconColumn {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.toggleButton {
  border: none;
  border-radius: 0;
  padding: 16px;
}
